import React from 'react';
import BaseDialog from '../Dialogs/BaseDialog'
import { AlertDialogFooter } from '../UI-CHAKRA/Dialog/AlertDialogFooter'
import { AlertDialogBody } from '../UI-CHAKRA/Dialog/AlertDialogBody'
import { Text } from '../UI-CHAKRA/Text';
import { Button } from '../UI-CHAKRA/Button';
import { useIsMobile } from '../../helpers/useIsMobile';

interface DialogAskForConfirmationProps {
  isOpen: boolean;
  title: string;
  text: string;
  cancelText: string;
  confirmText: string;
  onConfirm(): void;
  onClose(): void;
  onCancel(): void;
}

export function DialogAskForConfirmation(props: DialogAskForConfirmationProps) {
  const isMobile = useIsMobile();

  return (
    <BaseDialog isOpen={props.isOpen} onClose={props.onClose} width={isMobile ? '95vw' : '360px'}>
      <Text fontSize={'18px'} fontWeight={700} dangerouslySetInnerHTML={{ __html: props.title }} />

      <AlertDialogBody paddingLeft='0' paddingRight='0'>
        <Text fontSize={'14px'} dangerouslySetInnerHTML={{ __html: props.text }} />
      </AlertDialogBody>

      <AlertDialogFooter gap='16px' paddingLeft='0' paddingRight='0' paddingBottom='0'>
        <Button
          w={'100%'}
          onClick={props.onCancel}
          variant={'ghost'}
          bg={'gray.lightest'}
          color={'typography.darkest'}
          boxShadow={'none'}
          fontWeight={400}
          fontSize={'14px'}
        >
          {props.cancelText}
        </Button>

        <Button
          onClick={props.onConfirm}
          fontSize={'15px'}
          fontWeight={'600'}
          color={'#BF0711'}
          bg={'#FBEAE5'}
          w={'100%'}
          h={'40px'}
          variant={'ghost'}
        >
          {props.confirmText}
        </Button>
      </AlertDialogFooter>
    </BaseDialog>
  )
}
